import React from 'react';
import { Chip, Link, Stack, Typography } from '@mui/material';

import type { CommonTableColumn } from '../../../common-components/CommonTable';
import type { IKnowledgeBaseItem } from '../slice/types';
import moment from 'moment';

export function useKnowledgeBaseTableHeader() {
  const columns = React.useMemo<Array<CommonTableColumn<IKnowledgeBaseItem>>>(() => {
    return [
      {
        key: 'url',
        header: 'URL',
        minWidth: 320,
        render: (item) => (
          <Link href={item.url} target="_blank" rel="noreferrer" underline="hover" variant="body2" sx={{ fontWeight: 500 }}>
            {item.url || '—'}
          </Link>
        ),
      },
      {
        key: 'sourceType',
        header: 'Source Type',
        width: 180,
        render: (item) => (
          <Stack direction="row" spacing={1} alignItems="center">
            <Chip size="small" label={item.sourceType || '—'} variant="outlined" />
          </Stack>
        ),
      },
      {
        key: 'Created At',
        header: 'Created At',
        width: 180,
        render: (item) => (
          <Typography variant="body2" color="text.secondary" noWrap>
            {item.createdAt ? moment(item.createdAt).format('MMM D, YYYY h:mm A') : '—'}
          </Typography>
        ),
      },
    ];
  }, []);

  return columns;
}
